import firebase from 'firebase/app'
import 'firebase/auth'
// import firebaseui from 'firebaseui'
import * as firebaseui from 'firebaseui'

const firebaseService = {
  ui: null,
  uiConfig: null,
  auth: () => firebase.auth(),
  createUserWithEmailAndPassword: (email, password) => firebase.auth().createUserWithEmailAndPassword(email, password),
  getAuthenticationForm (container) {
    this.ui.start(container, this.uiConfig)
  },
  getToken () {
    const currentUser = firebase.auth().currentUser
    if (currentUser) {
      return currentUser.getIdToken(true)
    }
    return null
  },
  getUID () {
    const currentUser = firebase.auth().currentUser
    if (currentUser) {
      return currentUser.uid
    }
    return null
  },
  initializeFirebase (store) {
    firebase.initializeApp({
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID
    })

    this.uiConfig = {
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID
      ],
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.

          store.dispatch('handleUserSignInWithGoogleAuth', {
            isNewUser: authResult.additionalUserInfo.isNewUser,
            user: authResult.user
          })

          return false
        }
      }
    }

    this.ui = new firebaseui.auth.AuthUI(firebase.auth())
  },
  onAuthStateChanged: (fn) => firebase.auth().onAuthStateChanged(fn),
  sendPasswordResetEmail: (emailAddress) => firebase.auth().sendPasswordResetEmail(emailAddress),
  signInWithEmailAndPassword: (email, password) => firebase.auth().signInWithEmailAndPassword(email, password),
  signOut: () => firebase.auth().signOut()
}

export default firebaseService
